"use client";
import React, { useEffect, useState } from "react";
import HeroBanner from "../home-six/HeroBanner";
import FooterFive from "@/layouts/footers/FooterFive";
import axiosInstance from "@/service/axiosInstance";
import Loader from "@/components/Loader/Loader";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
  getSortedWRTpage,
} from "@/utils/utils";
import Faq from "@/components/faq";
import { useDispatch } from "react-redux";

const Page = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [bannerData, setbannerData] = useState([]);
  const [footerData, setFooterData] = useState([[]]);
  const [faqDAta, setFaqDAta] = useState([]);
  const [socialMedia, setSocialMedia] = useState([]);
  function getSortedSections(data: any, section: any) {
    return data
      .filter((item: any) => item.attributes.Section === section)
      .sort((a: any, b: any) => a.attributes.Sequence - b.attributes.Sequence)
      .map((item: any) => ({
        id: item.id,
        scetion: item.attributes.Section,
        page: item.attributes.Page,
        type: item.attributes.Type,
        Title: item.attributes.Title,
        URL: item.attributes.URL,
        content: item.attributes.Content,
        Image_Path: item.attributes.Image_Path,
        sequence: item.attributes.Sequence,
        academicYear: item.attributes.ac_academic_year.data?.attributes.name,
      }));
  }

  const getData = async () => {
    try {
      setLoading(true);
      // const token = localStorage.getItem("token")
      const resp: any = await axiosInstance.get("/homePage", {});

      // if (token) {
      //   if (
      //     resp?.isAuthorized?.status == 401 ||
      //     resp?.isAuthorized?.message ==
      //     "Token has expired"
      //   ) {
      //     console.log("Token has expired!");
      //     toast.error("Session expired please login again", {
      //       position: toast.POSITION.TOP_RIGHT,
      //       autoClose: 3000,
      //     });
      //     localStorage.removeItem("token");
      //     dispatch(logout());

      //     // router.push(`/login?redirect="true"`);

      //     // return;
      //   }
      // }

      const BannerData = getSortedSections(resp?.data?.data, "Banner");

      setbannerData(BannerData);
      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 1",
      );
      const faqData = getSortedWRTpage(resp?.data?.data, "FAQ");

      setFaqDAta(faqData);

      const footerData2 = await getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 2",
      );

      const footerData3 = await getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 3",
      );
      setFooterData([footerData1, footerData2, footerData3]);

      const socialMediaData = await getSortedSectionsWRTpage(
        resp?.data?.data,
        "Social Media",
        "Home Page",
      );

      setSocialMedia(socialMediaData);
      setData(resp?.data?.data);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {loading && <Loader />}
      {/* <HeaderOne style={true} /> */}
      <HeroBanner bannerData={bannerData} />
      <Faq data={faqDAta} />
      <FooterFive data={footerData} socialMedia={socialMedia} />
    </>
  );
};

export default Page;
